import { useState } from "react";
import { Link } from "react-router-dom";

type Period = "weekly" | "monthly" | "alltime";
type Category = "streak" | "wisdom" | "events" | "badges";

const MOCK_LEADERS = [
  { rank: 1,  name: "Priya K.",    avatar: "P", streak: 92,  wisdom: 145, events: 8, badges: 12 },
  { rank: 2,  name: "Arjun M.",   avatar: "A", streak: 84,  wisdom: 132, events: 6, badges: 10 },
  { rank: 3,  name: "Seeker #234", avatar: "S", streak: 77,  wisdom: 119, events: 5, badges: 9  },
  { rank: 4,  name: "Kavitha R.", avatar: "K", streak: 71,  wisdom: 104, events: 7, badges: 8  },
  { rank: 5,  name: "Rahul P.",   avatar: "R", streak: 65,  wisdom: 98,  events: 4, badges: 7  },
  { rank: 6,  name: "Anita S.",   avatar: "A", streak: 58,  wisdom: 87,  events: 3, badges: 6  },
  { rank: 7,  name: "Seeker #891", avatar: "S", streak: 52,  wisdom: 76,  events: 2, badges: 5  },
  { rank: 8,  name: "Maya T.",    avatar: "M", streak: 45,  wisdom: 65,  events: 3, badges: 4  },
  { rank: 9,  name: "Devraj N.",  avatar: "D", streak: 38,  wisdom: 54,  events: 2, badges: 3  },
  { rank: 10, name: "Lakshmi V.", avatar: "L", streak: 31,  wisdom: 43,  events: 1, badges: 2  },
];

const CAT_LABELS: Record<Category, string> = {
  streak: "Day Streak",
  wisdom: "Articles Read",
  events: "Events Attended",
  badges: "Badges Earned",
};

function getMedalEmoji(rank: number) {
  if (rank === 1) return "🥇";
  if (rank === 2) return "🥈";
  if (rank === 3) return "🥉";
  return null;
}

export function LeaderboardPage() {
  const [period, setPeriod] = useState<Period>("weekly");
  const [category, setCategory] = useState<Category>("streak");

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Community</p>
          <h1 className="display-2">Leaderboard</h1>
          <p className="hero__body" style={{ maxWidth: "520px", margin: "0 auto" }}>
            Celebrate the dedication of our top seekers. Rankings are updated daily.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container container--reading">
          {/* Controls */}
          <div className="leaderboard-controls">
            <div className="leaderboard-toggle-group">
              {(["weekly", "monthly", "alltime"] as Period[]).map((p) => (
                <button
                  key={p}
                  className={`leaderboard-toggle-btn ${period === p ? "active" : ""}`}
                  onClick={() => setPeriod(p)}
                >
                  {p === "alltime" ? "All Time" : p.charAt(0).toUpperCase() + p.slice(1)}
                </button>
              ))}
            </div>
            <div className="leaderboard-toggle-group">
              {(Object.keys(CAT_LABELS) as Category[]).map((c) => (
                <button
                  key={c}
                  className={`leaderboard-toggle-btn ${category === c ? "active" : ""}`}
                  onClick={() => setCategory(c)}
                >
                  {CAT_LABELS[c]}
                </button>
              ))}
            </div>
          </div>

          {/* Table */}
          <div className="leaderboard-table">
            {/* Header */}
            <div className="leaderboard-table__header">
              <span>#</span>
              <span>Seeker</span>
              <span>{CAT_LABELS[category]}</span>
            </div>
            {MOCK_LEADERS.map((l) => {
              const value = category === "streak" ? l.streak
                         : category === "wisdom" ? l.wisdom
                         : category === "events" ? l.events
                         : l.badges;
              const medal = getMedalEmoji(l.rank);
              return (
                <div key={l.rank} className={`leaderboard-row ${l.rank <= 3 ? "leaderboard-row--top" : ""}`}>
                  <div className="leaderboard-row__rank">
                    {medal ? <span>{medal}</span> : <span className="leaderboard-row__num">{l.rank}</span>}
                  </div>
                  <div className="leaderboard-row__user">
                    <div className="leaderboard-avatar">{l.avatar}</div>
                    <span className="leaderboard-row__name">{l.name}</span>
                  </div>
                  <div className="leaderboard-row__value">{value}</div>
                </div>
              );
            })}
          </div>

          {/* My position (placeholder) */}
          <div className="leaderboard-my-rank">
            <p style={{ color: "var(--c-ink-75)", fontSize: "0.9rem" }}>
              Complete your first practice session to appear on the leaderboard.
            </p>
            <Link to="/practice" className="btn btn--brand btn--sm">Start Practice</Link>
          </div>
        </div>
      </section>
    </>
  );
}
